import DataTable from "@standard/components/DataTable";
import { useDispatch } from "react-redux";
import axios from "@standard/axios";
import { JobStatusComponent } from "data/jobStatus";
import { JobStatusData } from "data";

const columns = [
  {
    label: "Project Code",
    name: "projectCode",
    align: "center",
    sortable: true,
    search: { type: "text" },
  },
  {
    label: "Job Name",
    name: "name",
    align: "left",
    sortable: true,
    search: { type: "text" },
  },
  {
    label: "Customer Name",
    name: "customerName",
    align: "left",
    sortable: true,
    search: { type: "text" },
  },
  {
    label: "Machine",
    name: "machine",
    align: "left",
    sortable: true,
    search: { type: "text" },
  },
  {
    label: "Work Date",
    name: "workDate",
    align: "center",
    sortable: true,
    // search: { type: "text" },
  },
  {
    label: "Manager",
    name: "managerName",
    align: "left",
    sortable: true,
    search: { type: "text" },
  },
  {
    label: "Safety",
    name: "safetyName",
    align: "left",
    sortable: true,
    search: { type: "text" },
  },
  {
    label: "Owner",
    name: "userName",
    align: "left",
    sortable: true,
    search: { type: "text" },
  },
  {
    label: "Status",
    name: "status",
    align: "center",
    sortable: true,
    search: { type: "checkbox", inline: true, datasource: JobStatusData },
  },
];

const config = {
  customFilters: [
    // {
    //   label: "Net From",
    //   name: "netFrom",
    //   type: "number",
    // },
    // {
    //   label: "Net To",
    //   name: "netTo",
    //   type: "number",
    // },
  ],
  enableActive: false,
  enableEdit: true,
  enableInsert: false,
  enableTrash: false,
  enableView: true,
  onBeforeBind: (data) => {
    return data.map((item) => {
      const { status } = item.values;

      item.values.status = <JobStatusComponent value={status} />;

      return item;
    });
  },
};

export default ({ url }) => {
  const dispatch = useDispatch();

  const buttons = [
    // {
    //   variant: "danger",
    //   label: '<i className="fa fa-print" aria-hidden="true"></i> Export Excel',
    //   onClick: () => {
    //     const printUrl = `${axios.defaults.baseURL}${url}/export`;
    //     const printUrlWithParam = dispatch(getURLSearchCriteria(printUrl));
    //     window.open(printUrlWithParam, "_blank");
    //   },
    // },
  ];

  config.buttons = buttons;

  return <DataTable columns={columns} url={url} {...config} />;
};
